export const environment = {
  production: true,

  authRedirectURI: 'https://portfolio.reconcept.nl/login/success/',
  canChangeBE: false,

  bugsnagApiKey: '4311abaa44d12ffdb34c0cfe6da7b7f5',
};
